// Client unico per le chiamate al backend: base URL, token, JSON e sessione scaduta
// sono gestiti qui invece che in ogni componente.
import { API_URL } from './config';
import { clearAuthSession } from './sessionCleanup';

export class ApiError extends Error {
  constructor(message, status, data) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.data = data;
  }
}

export function getAuthToken() {
  return localStorage.getItem('authToken');
}

function handleExpiredSession() {
  clearAuthSession({ preserveTheme: true });
  if (window.location.pathname !== '/login') {
    window.location.assign('/login?expired=1');
  }
}

function isJsonBody(body) {
  return body !== undefined && body !== null && typeof body === 'object'
    && !(body instanceof FormData) && !(body instanceof Blob);
}

/**
 * Come fetch, ma con percorso relativo all'API (es. '/api/user/profile').
 * - aggiunge `Authorization: Bearer <token>` se l'utente e loggato (auth: false per disattivarlo);
 * - serializza in JSON i body oggetto;
 * - se il backend risponde 401 a una richiesta autenticata, chiude la sessione e torna al login.
 * Restituisce la Response, quindi il chiamante continua a usare res.ok / res.json().
 */
export async function apiFetch(path, { body, headers, auth = true, ...options } = {}) {
  const token = auth ? getAuthToken() : null;
  const jsonBody = isJsonBody(body);

  const response = await fetch(`${API_URL}${path}`, {
    ...options,
    headers: {
      ...(jsonBody ? { 'Content-Type': 'application/json' } : {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...headers
    },
    body: jsonBody ? JSON.stringify(body) : body
  });

  if (token && response.status === 401) {
    handleExpiredSession();
  }

  return response;
}

/** Come apiFetch ma restituisce il JSON e lancia ApiError se la risposta non e ok. */
export async function apiJson(path, options) {
  const response = await apiFetch(path, options);
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new ApiError(data.message || `Errore ${response.status}`, response.status, data);
  }
  return data;
}

/** Salva il risultato di una partita per il paziente selezionato. */
export function saveGameResult({ gameId, elapsedTime, difficulty, numErrors }) {
  return apiJson('/api/saveresult', {
    method: 'POST',
    body: {
      trainerId: localStorage.getItem('trainerId'),
      userId: localStorage.getItem('nickname'),
      uuidGame: crypto.randomUUID(),
      uuidSession: crypto.randomUUID(),
      elapsedTime,
      gameId,
      difficulty,
      numErrors
    }
  });
}
